import React, { useEffect } from 'react';
import { postApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { FaultTypesForm } from '../../forms/faultTypes/FaultTypesForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { FaultTypeInputs } from '../../types/faultType';
import { API_URL } from '../../utils/apiUrl';

export function FaultTypesNew() {
  const { translate } = useTranslation();
  const transFormName = 'FaultType.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New fault type',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Fault types', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: FaultTypeInputs = {
    id: 0,
    name: '',
    visible: true,
  };

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    let isOk = false;
    startLoading();
    await postApi<FaultTypeInputs>({
      url: API_URL.FAULT_TYPE_POST,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper heading={translate!('New fault type', transFormName)}>
      <FaultTypesForm onSubmit={onSubmit} formData={formData} />
    </PageContentWrapper>
  );
}

export default FaultTypesNew;
